import $ from 'jquery'
import Swal from 'sweetalert2/dist/sweetalert2.js'

export default {
  init() {

    $(document).on( 'click', '.mimo-button.login', function(event) {
      $('html').removeClass('show-sidebar-menu show-sidebar-cart show-sidebar-register').addClass('show-sidebar-login')
    });

    $(document).on( 'click', '.login-shortcut', function(event) {
      $('html').addClass('show-sidebar show-sidebar-login')
      event.preventDefault()
    });
    
    $(document).on( 'click', '.mimo-button.register', function(event) {
      $('html').removeClass('show-sidebar-menu show-sidebar-cart  show-sidebar-login').addClass('show-sidebar-register')
    });

    $('.form-login').submit(function( event ) {

      event.preventDefault();

      var t = $(this);

      t.find('.form-group').removeClass('has-error').find('span').remove();

      t.addClass('is-loading');
      t.find('.mimo-button').addClass('is-loading');

      $.ajax({
        type: 'POST',
        dataType: 'json',
        url: JWD.ajaxurl,
        data: t.serialize(),
        success : function( data ){

          t.removeClass('is-loading');
          t.find('.mimo-button').removeClass('is-loading');

          if ( data.errors ) {

            if( data.username )
              $('#username-login', t).closest('.form-group').addClass('has-error').append(data.username);

            if( data.password )
              $('#password-login', t).closest('.form-group').addClass('has-error').append(data.password);

          }else{

            $('html').removeClass('show-sidebar')

            const Toast = Swal.mixin({
              toast: true,
              position: 'bottom-end',
              showConfirmButton: false,
              timer: 1500,
              timerProgressBar: true,
              onOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
              }
            })
            
            Toast.fire({
              icon: 'success',
              title: ' เข้าสู่ระบบสำเร็จ '
            }).then(function() {
              location.reload();
            })

          }

        },
        complete: function(data){},
        error : function( err ){
        }

      });

    });

    $('.form-register').submit(function( event ) {

      event.preventDefault();

      var t = $(this);

      t.find('.form-group').removeClass('has-error').find('span').remove();

      t.addClass('is-loading');
      t.find('.mimo-button').addClass('is-loading');

      $.ajax({
        type: 'POST',
        dataType: 'json',
        url: JWD.ajaxurl,
        data: t.serialize(),
        success : function( data ){

          t.removeClass('is-loading');
          t.find('.mimo-button').removeClass('is-loading');

          if ( data.errors ) {

            if( data.username_unavailable )
              $('#username', t).closest('.form-group').addClass('has-error').append(data.username_unavailable);

            if( data.username_invalid )
              $('#username', t).closest('.form-group').addClass('has-error').append(data.username_invalid);

            if( data.email_invalid )
              $('#email', t).closest('.form-group').addClass('has-error').append(data.email_invalid);

            if( data.email_used )
              $('#email', t).closest('.form-group').addClass('has-error').append(data.email_used);

            if( data.password_empty )
              $('#password', t).closest('.form-group').addClass('has-error').append(data.password_empty);

          }else{

            $('html').removeClass('show-sidebar')

            const Toast = Swal.mixin({
              toast: true,
              position: 'bottom-end',
              showConfirmButton: false,
              timer: 1500,
              timerProgressBar: true,
              onOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
              }
            })
            
            Toast.fire({
              icon: 'success',
              title: ' สมัครสมาชิกสำเร็จ '
            }).then(function() {
              location.reload();
            })

          }

        },
        complete: function(data){},
        error : function( err ){
        }

      });

    });
    
    $( document ).on( 'click', '.facebook-login-button', function(event) {

      event.preventDefault();

      var t = $(this);

      t.addClass('is-loading');

      FB.login(function(response) {

        if (response.authResponse) {

          FB.api('/me', {fields: 'email,first_name,last_name,name,picture,link,id'}, function(response) {

            var fb_response = response;
            $.ajax({
              type: 'POST',
              dataType: 'json',
              url: JWD.ajaxurl,
              data: {
                fb_response: fb_response,
                security: t.data('fb_nonce'),
                action: 'facebook_login',
              },
              success : function( data ){

                t.removeClass('is-loading');
                t.find('.mimo-button').removeClass('is-loading');

                $('html').removeClass('show-sidebar')

                const Toast = Swal.mixin({
                  toast: true,
                  position: 'bottom-end',
                  showConfirmButton: false,
                  timer: 1500,
                  timerProgressBar: true,
                  onOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer)
                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                  }
                })
                
                Toast.fire({
                  icon: 'success',
                  title: ' เข้าสู่ระบบสำเร็จ '
                }).then(function() {
                  location.reload();
                })

              },
              complete: function(data){},
              error : function( err ){}
            });

          });

        } else {

          t.removeClass('is-loading');
          t.find('.mimo-button').removeClass('is-loading');

          console.log('User cancelled login or did not fully authorize.');

        }

      }, {scope: 'public_profile,email'});

    });

  },

  finalize() {
  },
};